import { Card, Tag } from "antd";
import { Link } from "react-router-dom";
import { format, fromUnixTime } from "date-fns";
import formatMoney from "../../../utils/formatMoney";

const STATUS_MAP = {
    1: { label: "Chờ duyệt", color: "orange" },
    2: { label: "Đã xử lý", color: "green" },
    3: { label: "Đã huỷ", color: "red" },
};

function DashboardRecentActivity({ payments }) {
    return (
        <Card
            title="Hoạt động gần đây"
            extra={
                <Link to="/withdraw" className="text-blue-600 text-sm hover:underline">
                    Xem tất cả →
                </Link>
            }
            className="shadow-sm"
        >
            {payments.length === 0 ? (
                <div className="text-center text-content-3 py-8 text-sm">Chưa có dữ liệu</div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="text-left text-content-3 border-b">
                                <th className="py-2 pr-4 font-medium">ID</th>
                                <th className="py-2 pr-4 font-medium">User</th>
                                <th className="py-2 pr-4 font-medium">Số tiền</th>
                                <th className="py-2 pr-4 font-medium">Ngày tạo</th>
                                <th className="py-2 font-medium">Trạng thái</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payments.slice(0, 8).map((p) => {
                                const status = STATUS_MAP[p.status] || { label: String(p.status), color: "default" };
                                return (
                                    <tr key={p.paymentId} className="border-b last:border-0 hover:bg-surface-sunken transition-colors">
                                        <td className="py-2 pr-4">
                                            <Link to={`/withdraw/${p.paymentId}`} className="text-blue-600 hover:underline">
                                                #{p.paymentId}
                                            </Link>
                                        </td>
                                        <td className="py-2 pr-4 text-content-2">
                                            {p.user?.name || `User #${p.userId}`}
                                        </td>
                                        <td className="py-2 pr-4 font-medium">
                                            {formatMoney.format(p.amount)}
                                        </td>
                                        <td className="py-2 pr-4 text-content-3">
                                            {p.createTime
                                                ? format(fromUnixTime(p.createTime), "dd/MM HH:mm")
                                                : "—"}
                                        </td>
                                        <td className="py-2">
                                            <Tag color={status.color}>{status.label}</Tag>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </Card>
    );
}

export default DashboardRecentActivity;
